import React from 'react';
import Card from 'react-bootstrap/Card';

const Dashboard = () => {
  return (
    <div className='row'>
      <div className='col-md-12'>
        <Card className='mb-4'>
          <Card.Body>
            <Card.Title>Admin Dashboard</Card.Title>
            <Card.Text>Welcome to the admin dashboard!</Card.Text>
          </Card.Body>
        </Card>
      </div>      
    </div>
  );
};

export default Dashboard;
